
import { useAuth } from "@/components/auth-provider";
import HeroBanner from "@/components/hero-banner";
import React from "react";
import { useTranslation } from "react-i18next";

export default function ProfilePage() {
  // sample user data — replace with real data as needed
  const {user }= useAuth();
  const { t } = useTranslation();
  const createdAtDate = user?.created_at ? new Date(user.created_at as any) : null
  const createdAtLabel =
    createdAtDate && !isNaN(createdAtDate.getTime())
      ? createdAtDate.toLocaleDateString()
      : ""
//Test here
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-pink-50 flex flex-col items-center pb-12">
      <div className="w-full max-w-md px-4 mt-8">
        <div className="bg-white rounded-2xl shadow-md p-6">
          <div className="flex flex-col items-center">
            <div className="w-20 h-20 rounded-full bg-pink-100 flex items-center justify-center">
              <span className="text-pink-600 font-extrabold text-xl">
                {`${user?.firstname} ${user?.lastname}`
                  .split(" ")
                  .map((n) => n.charAt(0))
                  .slice(0, 2)
                  .join("")
                  .toUpperCase()}
              </span>
            </div>

            <h3 className="mt-4 text-center font-bold text-lg text-slate-800">
              {`${user?.firstname} ${user?.lastname}`}
            </h3>

            <p className="mt-2 text-sm text-gray-500">{user?.mobile}</p>

            <div className="mt-3">
              <span className="text-pink-500 font-semibold">{user?.active ? t("Active") : t("Inactive")}</span>
            </div>

            <p className="mt-4 text-xs text-gray-400">
              {t("Member since")} {createdAtLabel || "—"}
            </p>
          </div>
        </div>

       <HeroBanner />
      </div>
    </div>
  );
}
// ...existing code...